// extracted by mini-css-extract-plugin
export var container = "_bo-1";
export var cornerButtonContainer = "_bo-5";
export var disabled = "_bo-2";
export var fileContainer = "_bo-4";
export var hiddenInput = "_bo-3";
export var widthContainer = "_bo-0";